import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { Icon } from '@codex-brightworld/icons';

const Wrapper = styled.ul`
  font-size: 13px;
  border-radius: 4px;

  ${({
    theme
  }) => css`
    background-color: ${theme.colors.shades[7]};
    border: solid 1px ${theme.colors.shades[5]};
    padding: 0 ${theme.spacing[1]};
  `};
`;

export const Item = styled.li`
  border-bottom: 1px solid #d8d8d8;
  list-style: none;
  margin: 0;

  &:last-child {
    border-bottom: none;
  };
`;

const Link = styled.a`
  ${({
    theme
  }) => css`
    display: flex;
    color: ${theme.colors.link.default};
    text-decoration: none;
    padding: ${theme.spacing[2]} ${theme.spacing[1]};
    line-height: 1.3;

    &:hover {
      text-decoration: underline;
    }

    ${Icon} {
      display: block;
      color: ${theme.colors.shades[2]};
      margin-right: ${theme.spacing[1]};
      text-align: center;

      svg {
        height: 15px;
      }
    }
  `};
`;

/**
 * @tags styled, list, menu, navigation
 */
const ListMenu = props => (
  <Wrapper {...props} data-qa={props.qa}>
    {props.items.map((item, index) => props.children(item, index, Item, Link))}
  </Wrapper>
);

ListMenu.displayName = 'ListMenu';

ListMenu.propTypes = {
  /**
   * Item renderer.
   *
   * @param {mixed} item
   * @param {number} index
   * @param {Item} ItemWrapper
   * @param {Link} LinkWrapper
   * @return {React.Node}
   */
  children: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  qa: PropTypes.string
};

ListMenu.defaultProps = {
  children: (item, index, ItemWrapper, LinkWrapper) => (
    <ItemWrapper key={index}>
      <LinkWrapper href={item.href || '#'} onClick={item.onClick}>
        <Icon icon={item.icon} />{item.label}
      </LinkWrapper>
    </ItemWrapper>
  ),
  qa: undefined
};

/** @component */
export default ListMenu;
